import SahamDialog from 'components/SahamDialog';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  padding-top: 0px;
  .title {
    text-align: left;
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: #384264;
    opacity: 1;
    padding: 10px;
  }
  .headerTitle {
    text-align: left;
    font-size: 13px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 10px;
    font-weight: Bold;
  }
  .rowTable {
    padding: 12px;
  }
  .row {
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 11px;
    color: #2b2727;
  }
  .claims {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .recap {
    background: transparent
      linear-gradient(229deg, #707891 0%, #0b7cc5 0%, #56afbb 88%, #5db4ba 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 46px;
    height: 46px;
    border-radius: 300px;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .titleContainer {
    display: flex;
  }
  .recapValue {
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: ${COLORS.WHITE};
    opacity: 1;
  }
  .row:hover {
    cursor: pointer;
    background-color: #f7f7f7;
  }
  .summary-button {
    background: ${COLORS.WHITE} 0% 0% no-repeat padding-box;
    border: 1px solid ${COLORS.GREY};
    &:hover {
      background-color: ${COLORS.WHITE};
    }
  }
  .disabled-click {
    pointer-events: none;
  }
  .consult-icon {
    width: 12px;
    height: 12px;
  }
  .consult-text {
    font-size: 14px;
    margin-right: 10px;
    visibility: hidden;
  }
  .consult-container {
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .consult-container:hover .consult-text {
    visibility: visible;
    transition: 1s ease in;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
`;

export const Dialog = styled(SahamDialog)`
  .MuiDialogContent-root .content {
    background-color: skyblue;
    font-size: 18px;
    min-width: 316px;
  }
  .info-message {
    padding: 10px 0;
    font-style: italic;
    font-size: 12px;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
`;
